<app-expandable-panel #panel [collapseOn]="otherTabActivated$">
<ng-container *ngIf="!viewTemplate">
  <editor class="flex-body p b0" style="height:100%;" #editor apiKey="no-api-key" id="{{richTextTemplate.id}}" name="template_body"
          [(ngModel)]="richTextTemplate.body"
          [init]="init_tiny" required>
  </editor>

  <div class="flex-footer note-footer p-sm">
    <span class="note-footer-side note-name" [title]="richTextTemplate?.name">{{richTextTemplate?.name}}</span>
    <div class="note-footer-actions">
      <ng-container  *ngIf="!saving">
        <button class="btn btn-secondary btn-min mr" type="button" (click)="signRichTextTemplate(richTextTemplate, 'signed')">Sign</button>
        <button class="btn btn-tertiary btn-outline" type="button" (click)="saveAsDraft(richTextTemplate, 'drafted')">Save as Draft</button>
      </ng-container>
      <ng-container *ngIf="saving">
        <i class="fa fa-spinner fa-spin"></i>
      </ng-container>
    </div>
    <span class="note-footer-side text-right">
      <ng-container *ngTemplateOutlet="expandToggle"></ng-container>
    </span>
  </div>
</ng-container>

<ng-container *ngIf="viewTemplate">
  <div class="p flex-body scroll-browser" [innerHTML]="signedBodyHtml | safeHtml"></div>
  <div class="flex-footer note-footer p-sm">
    <span class="note-footer-side note-name" [title]="richTextTemplate?.name">{{richTextTemplate?.name}}</span>
    <div class="note-footer-actions">
      <label class="label label-primary fs12 fw-500 mr-sm">Signed by</label>
      <span class="text-capitalize" *ngIf="richTextTemplate?.modifier_name"> {{ richTextTemplate?.modifier_name }}</span>
      on {{richTextTemplate.last_modified_at | date: 'MMMM d, y, h:mm a' }}
      <button class="btn btn-secondary btn-min ml-xl" type="button" (click)="printRichText.emit('Print')">Print</button>
    </div>
    <span class="note-footer-side text-right">
      <ng-container *ngTemplateOutlet="expandToggle"></ng-container>
    </span>
  </div>
</ng-container>
</app-expandable-panel>

<ng-template #expandToggle>
  <button class="btn btn-tertiary btn-outline btn-sm" type="button" (click)="panel.toggle()"
          [title]="panel.expanded ? 'Collapse (Esc)' : 'Expand for a larger view'">
    <i class="fa" [ngClass]="panel.expanded ? 'fa-compress' : 'fa-expand'"></i> {{panel.expanded ? 'Collapse' : 'Expand'}}
  </button>
</ng-template>
